<template>
    <el-row class="mg-b5">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item class="my-form-item">
                        <el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
                            v-model="quertInfo.searchTime" start-placeholder="开始日期" value-format="yyyy-MM-dd"
                            style="width: 200px" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="my-form-item">
                        <el-input size="mini" placeholder="请输入订单号查询" clearable v-model="quertInfo.objMap.search"
                            style="width: 180px" prefix-icon="el-icon-search"></el-input>
                    </el-form-item>
                    <el-form-item class="my-form-item">
                        <el-input size="mini" placeholder="请输入询价单号查询" clearable v-model="quertInfo.objMap.xjdh"
                            style="width: 180px" prefix-icon="el-icon-search"></el-input>
                    </el-form-item>
                    <el-form-item class="my-form-item">
                        <el-button size="mini" type="primary" @click="onSearch" >查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 订单列表 -->
            <OmgOrderTable
				ref="OrderTableRef"
                :pageFlag="pageFlag"
                :tableData="tableData"
                @callback="OrderTableCallback"
                :currencyObj="currencyInfo.obj"
                :count="count"
				:loading="loading"
                :tableHeight="omgOrderTableHeight"
                >
            </OmgOrderTable>
        </el-card>
    </el-row>
</template>
<script>
import { orderList } from '@/api/omg/index.js';
import OmgOrderTable from '@/components/OmgOrderTable'
export default {
    props:['pageFlag'],
    components:{
        OmgOrderTable
    },
    computed: {
        PAGESIZE:function(){
            return this.$store.getters['app/sizeInfo'];
        },
        currencyInfo:function(){
            return this.$store.getters['app/currencyInfo'];
        },
        userInfo:function(){
            return this.$store.getters['user/user'];
        },
        omgOrderTableHeight:function(){
            return this.count>0?this.PAGESIZE.h-290:this.PAGESIZE.h-258
        },
    },
    data(){
        return {
            loading:false,
            tableData:[],
            count:0,
            quertInfo: {
                page: 1, //当前页码
                limit: 20, //当前每页显示的数量
                searchTime: [],
                objMap: {
                    // keyword: '',
                    // state:1,		 //采购员部分  待发布： 0，确认中 1 已签收2 已入库 3 已开票 4,
                }
            },
        }
    },
    created(){
        this.getList()
    },
    methods:{
        // 采购员部分
        getOrderStateType(){
            let type = '';
            if(this.pageFlag == 'waitRelease'){
                type = '0'
            }
            if(this.pageFlag == 'affirmIng'){
                type = '1'
            }
            if(this.pageFlag == 'affirmEnd'){
                type = '2'
            }
            if(this.pageFlag == 'sendPlan'){
                type = '3'
            }
            if(this.pageFlag == 'signIn'){
                type = '4'
            }
            if(this.pageFlag == 'inStore'){
                type = '5'
            }
            if(this.pageFlag == 'invoice'){
                type = '6'
            }
            return type
        },
        // 采购员部分
        getOrderStateGYSType(){
            let type = '';
            if(this.pageFlag == 'waitAffirm'){   //待确认
                type = '1'
            }
            if(this.pageFlag == 'isAffirm'){    //已确认
                type = '2'
            }
            if(this.pageFlag == 'hasPlan'){     //发货计划
                type = '3'
            }
            if(this.pageFlag == 'signInCus'){   //已签收
                type = '4'
            }
            if(this.pageFlag == 'inStoreCus'){  //已入库
                type = '5'
            }
            if(this.pageFlag == 'invoiceCus'){  //已开票
                type = '6'
            }
            return type
        },
        async getList(){
            let _this = this;
            _this.loading = true;
            let prama = {..._this.quertInfo};
            if(this.checkRole('cgy_role')){ // 采购员
                prama.objMap.state = this.getOrderStateType()
                 const { data: res } = await orderList(prama)
                _this.loading = false
                if (res.code == 0) {
                    _this.tableData = res.data;
                    _this.count = res.count;
                }
            }else{
                 prama.objMap.state = this.getOrderStateGYSType();
                 const { data: res } = await orderList(prama)
                 _this.loading = false
                 if (res.code == 0) {
                    _this.tableData = res.data;
                    _this.count = res.count;
                }
            }

        },
        onSearch(){
            this.quertInfo.page = 1;
            this.getList()
        },
        OrderTableCallback(){

        },
    },
    watch:{
        pageFlag:function(val){
            this.tableData = [];
            this.quertInfo={
                page: 1, //当前页码
                limit: 20, //当前每页显示的数量
                objMap: {
                    keyword: '',
                }
            };
            this.$nextTick(()=>{
                this.getList();
            })
        }
    }
}
</script>
<style scoped="scoped">
</style>
